<template>
	<div>
		<div>
			<v-card class="d-flex flex-row mb-6" flat >
				<v-card  flat >
					<img src="@/assets/order.svg" alt="img"  width="25px" class="mt-3 mr-1">
				</v-card>
				<v-card  flat >
					<p class="secodry-text-2">{{$lang.SHIPMENT_ID}}</p>
					<p class="sub-title-text">{{shipment_details.shipment_id}}</p>
				</v-card>
			</v-card>
			<div class="mb-3" v-if="shipment_details.shipment_status">
				<change-status-dropdown :shipment="shipment_details"  v-if="$store.state.user_type!=$keys.WHOLESALER"/>
				
				<span  v-if="$store.state.user_type==$keys.WHOLESALER" :class="getClassSatus(shipment_details.shipment_status)">{{shipment_details.shipment_status}}</span>
			</div>
			<div class="pb-3" v-if="shipment_details.challan_number">
				<p class="sub-title-text-dark">{{$lang.RETURN_REASON}}</p>
				<p class="secondary-text">{{shipment_details.return_reason}}</p>
			</div>
			<div class="pb-3">
				<p class="sub-title-text-dark">{{$lang.CHALLAN_NUMBER}}</p>
				<p class="secondary-text">{{shipment_details.challan_number}}</p>
			</div>
			<!--  -->
			<div class="pb-3" v-if="$store.state.user_type!=$keys.WHOLESALER">
				<p class="sub-title-text-dark">{{$lang.WHOLESALER_DETAILS}}</p>
				<p class="secondary-text">{{shipment_details.wholesaler_firm_name}}</p>
				<p class="secondary-text">{{$lang.MOBILE_PREFIX}}{{shipment_details.wholesaler_mobile_number}}</p>
			</div>
			<!--  -->
			<div class="pb-3">
				<p class="sub-title-text-dark">{{$lang.RETAILER_DETAILS}}</p>
				<p class="secondary-text">{{shipment_details.retailer_firm_name}}</p>
				<p class="secondary-text" v-if="shipment_details.retailer_mobile_number">{{$lang.MOBILE_PREFIX}}{{shipment_details.retailer_mobile_number}}</p>
				<p class="secondary-text">
					<v-icon size="16" color="primary">mdi-map-marker</v-icon>
					{{shipment_details.retailer_location}}</p>
				<!-- <p class="secondary-text">{{shipment_details.retailer_firm_name}}</p> -->
			</div>
			<div class="pb-3" v-if="shipment_details.pickup_agent_mobile_number||shipment_details.pickup_agent_name">
				<p class="sub-title-text-dark">{{$lang.PICKUP_AGENT}} </p>
				<p class="secondary-text">{{shipment_details.pickup_agent_name}}</p>
				<p class="secondary-text" v-if="shipment_details.pickup_agent_mobile_number">{{$lang.MOBILE_PREFIX}}{{shipment_details.pickup_agent_mobile_number}}</p>
			</div>
			<!--  -->
			<div class="pb-3" v-if="shipment_details.delivery_agent_mobile_number && shipment_details.delivery_agent_name">
				<p class="sub-title-text-dark">{{$lang.DELIVERY_AGENT}}</p>
				<p class="secondary-text">{{shipment_details.delivery_agent_name}}</p>
				<p class="secondary-text">{{$lang.MOBILE_PREFIX}}{{shipment_details.delivery_agent_mobile_number}}</p>
			</div>
			<!--  -->
			<div class="pb-3" v-if="shipment_details.received_by_name">
				<p class="sub-title-text-dark">{{$lang.RECEIVED_BY}}</p>
				<p class="secondary-text">{{shipment_details.received_by_name}}</p>
				<p class="secondary-text" v-if="shipment_details.received_by_number" >{{$lang.MOBILE_PREFIX}}{{shipment_details.received_by_number}}</p>
			</div>
			<!--  -->
		</div>

	</div>
</template>
<script type="text/javascript">
export default {
	components: {
		// AssignPickupAgentDailog :()=>import('./AssignPickupAgentDailog.vue'),
		ChangeStatusDropdown :()=>import('./ChangeStatusDropdown.vue'),
	},
	props:['shipment_details'],
}

</script>